/**
 * Defensive helpers for values that MIGHT come back from the API as
 * encrypted strings ("enc:v1:...") when the backend's ENCRYPTION_KEY is
 * misconfigured. Never a substitute for the backend decrypting properly —
 * it just prevents raw ciphertext from bleeding into the UI while ops
 * fixes the container env.
 */

const ENC_PREFIX = "enc:v1:";

export function isEncrypted(v) {
  return typeof v === "string" && v.startsWith(ENC_PREFIX);
}

/** Return the string if it's plaintext, otherwise a placeholder. */
export function plain(v, placeholder = "—") {
  if (v == null) return placeholder;
  if (typeof v !== "string") return v;
  return isEncrypted(v) ? placeholder : v;
}

/** Walk a payload and count how many encrypted strings leaked. */
export function countEncryptedLeaks(o) {
  let n = 0;
  const walk = (x) => {
    if (isEncrypted(x)) n += 1;
    else if (Array.isArray(x)) x.forEach(walk);
    else if (x && typeof x === "object") Object.values(x).forEach(walk);
  };
  walk(o);
  return n;
}
